export const getLastOnlineStatus = (dateVisited: string) => {
  if (!dateVisited) {
    return ''
  }

  const now = new Date()
  const diffInMs = now.getTime() - new Date(dateVisited).getTime()
  const diffInMinutes = Math.floor(diffInMs / 60000)

  const timeUnits = [
    { unit: 'year', value: Math.floor(diffInMinutes / 525600) },
    { unit: 'week', value: Math.floor(diffInMinutes / 10080) },
    { unit: 'day', value: Math.floor(diffInMinutes / 1440) },
    { unit: 'hour', value: Math.floor(diffInMinutes / 60) },
    { unit: 'minute', value: diffInMinutes },
  ]

  if (diffInMinutes < 10) {
    return 'Online'
  }

  for (const { unit, value } of timeUnits) {
    if (value > 0) {
      return `${value} ${unit}${value > 1 ? 's' : ''} ago`
    }
  }

  return ''
}



// WEBPACK FOOTER //
// ./src/helpers/timeAgoHelper.tsx